import { render } from "./need-reschedule.vue?vue&type=template&id=4dd630c0"
import script from "./need-reschedule.vue?vue&type=script&lang=js"
export * from "./need-reschedule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__